var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation-menu'),_c('v-container',{staticClass:"mt-4 pa-2",attrs:{"fluid":""}},[_c('resource-container-to-process')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }